import { useState, useCallback, useRef } from 'react'
import abcjs from 'abcjs'

export function useMusicPlayback() {
  const [isPlaying, setIsPlaying] = useState(false)
  const synthRef = useRef<any>(null)

  const playInterval = useCallback(async (abc: string, tempo = 80) => {
    setIsPlaying(true)
    try {
      const visualObj = abcjs.renderAbc('*', abc, { })[0]
      if (!synthRef.current) {
        synthRef.current = new abcjs.synth.CreateSynth()
      }
      await synthRef.current.init({
        visualObj,
        options: { qpm: tempo },
      })
      await synthRef.current.prime()
      await synthRef.current.start()

      // Wait for playback to finish
      const duration = synthRef.current.synthControl
        ? synthRef.current.synthControl.duration
        : 2
      await new Promise((resolve) => setTimeout(resolve, (duration || 2) * 1000))
    } catch (err) {
      console.error('Music playback error:', err)
    } finally {
      setIsPlaying(false)
    }
  }, [])

  const stop = useCallback(() => {
    if (synthRef.current) {
      try {
        synthRef.current.stop()
      } catch {}
    }
    setIsPlaying(false)
  }, [])

  return { playInterval, stop, isPlaying }
}
